module.exports = __webpack_public_path__ + "img/DE00181.56ae0510.svg";